<template>
  <div class="variables-menu-container">
    <v-menu offset-y :max-height="220">
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" class="menu-activator" v-on="on">
          <span class="menu-activator-label" :style="{ color: activatorColor }">{{ label }}</span>
          <mf-icon icon="data_object" :color="activatorColor" size="20" />
        </div>
      </template>
      <v-list>
        <v-list-item v-for="(item, index) in items" :key="index" @click="setVariable(item)">
          <div class="variable-data-container">
            <div class="variable-icon-section" :style="{ backgroundColor: backgroundColor }">
              <mf-icon icon="data_object" size="20" :color="iconColor" />
            </div>
            <div class="variable-text-section">
              <span :class="`variable-text-title-${variant}`">{{ item.title }}</span>
              <span v-if="variant === 'variables'" class="variable-text-description">{{ item.description }}</span>
              <span class="variable-text-char-count"> Contabiliza {{ item.charCount }} digito{{ item.charCount !== 1 ? 's' : '' }} </span>
            </div>
          </div>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'VariablesMenu',
  components: {},
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: 'Adicionar variável',
    },
    variant: {
      type: String,
      default: 'variables',
      validator: (value) => ['subvariables', 'variables'].includes(value),
    },
  },
  computed: {
    backgroundColor() {
      const colors = {
        subvariables: '#ECEDF0',
        variables: '#efe0fb',
      }
      return colors[this.variant]
    },
    iconColor() {
      const colors = {
        subvariables: '#31363B',
        variables: '#962EE7',
      }
      return colors[this.variant]
    },
    activatorColor() {
      const colors = {
        subvariables: 'cinza-d20',
        variables: '#962EE7',
      }
      return colors[this.variant]
    },
  },
  methods: {
    setVariable(variable) {
      this.$emit('set-variable', variable.title)
    },
  },
}
</script>

<style lang="scss" scoped>
.variables-menu-container {
  .menu-activator {
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: flex-end;
    .menu-activator-label {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
    }
  }
}

.variable-data-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding: 8px;
  cursor: pointer;
  .variable-icon-section {
    height: 32px;
    width: 32px;
    padding: 0 8px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .variable-text-section {
    display: flex;
    flex-direction: column;
    gap: 2px;
    .variable-text-char-count {
      font-size: 12px;
      font-weight: 400;
      line-height: 15.6px;
      color: $cinza-0;
    }
    .variable-text-title-subvariables {
      font-size: 14px;
      font-weight: 700;
      line-height: 16.8px;
      color: $cinza-d20;
    }
    .variable-text-title-variables {
      font-size: 14px;
      font-weight: 600;
      line-height: 16.8px;
      color: $cinza-d10;
    }
    .variable-text-description {
      font-size: 12px;
      font-weight: 400;
      line-height: 15.6px;
      color: $cinza-l40;
    }
  }
}

::v-deep .v-list-item {
  padding: 0 8px;
}
</style>
